<template>

  <div>
    <div class="exercise-item text-left">
      <span class="time" v-if="examResults">
       <span v-if="CelotnoVprasanje.correct != null && CelotnoVprasanje.correct !== 0">
          <i v-if="CelotnoVprasanje.correct" class="fa fa-check"></i>
          <i v-else class="fa fa-times"></i>
        </span>
      </span>
      <span class="time" v-else>
       <span v-if="isCorrect != null">
          <i v-if="isCorrect" class="fa fa-check"></i>
          <i v-else-if="!isCorrect" class="fa fa-times"></i>
        </span>
      </span>
      <h4 class="exercise-header">
        <div v-if="odgovori">
          <span v-for="(instanca, index) in splited" :key="index" >
            <input type="text" v-if="instanca === ' '" v-model="odgovori[index].value">
            <span v-else v-html="instanca"></span>
          </span>
        </div>
      </h4>
      <div class="exercise-body text-left">
        <span class="row" v-if="showLastInput">
          <input v-if="examResults" disabled class="form-control input-lg" :class="[CelotnoVprasanje.correct === true ? 'correct' : '', CelotnoVprasanje.correct === false ? 'incorrect' : '']" :value="submitInfo.selectedAnswer.slice(16, -14)" id="comment" type="text">
          <input :placeholder="(showAnswer ? CelotnoVprasanje.answers[0].correct + ' ' : '')" v-else @keyup.enter="eval" class="form-control input-lg" v-model="selectedAns" id="comment" type="text" @wheel="$event.target.blur()">
          <span v-if="jeAdmin && CelotnoVprasanje.solvedAt" class="pull-left">{{CelotnoVprasanje.solvedAt | formatDate}}</span>
        </span>
      </div>
      <div class="exercise-footer">
        <template v-if="isExam">
          <button v-if="!examResults" @click.prevent="eval" type="submit" class="btn btn-success pull-left" :class="{'small-button':detectMobile() && scoringSettings && scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum}">{{$t('pages.exercise.evaluateExam')}}</button>
          <button v-if="!examResults" @click.prevent="clearExercise" type="submit" class="btn btn-warning pull-left" :class="{'small-button':detectMobile() && scoringSettings && scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum}">{{($t('pages.exercise.examClearExercise'))}}</button>
          <!-- Odgovori -->
          <ShowSolutionExamResults :examResults="examResults" :CelotnoVprasanje="CelotnoVprasanje" :nameOfTheParent="Name" v-if="examResults"/>
          <!-- Gumb za prikaz detaljnih resitvi -->
          <SolutionModal :CelotnoVprasanje="CelotnoVprasanje" :solutionKeyId="solutionKey" :i="index" :identifier="identifier" :exerciseVersionId="exerciseVersionId" :parentIdentifier="parent" v-if="examResults"/>

          <!--Tocke-->
          <div class="pull-right" style="margin-top: 14px" v-if="!examResults">
            <span v-if="scoringSettings" class="text-muted">{{$t('pages.exercise.points')}}: {{scoringSettings[CelotnoVprasanje.guid].posPoints}}
              <span v-if="scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum">{{$t('pages.exercise.points')}}: (-{{scoringSettings[CelotnoVprasanje.guid].negPoints}})</span>
            </span>
          </div>
          <div class="pull-right" style="margin-top: 14px" v-else-if="CelotnoVprasanje.points !== null && CelotnoVprasanje.maxPoints !== null">
            <span class="text-muted">
              {{$t('pages.exercise.points')}}: {{CelotnoVprasanje.points}}/{{CelotnoVprasanje.maxPoints}}
            </span>
          </div>
          <div class="pull-right" style="margin-top: 14px" v-else>
            <span class="text-muted">{{$t('pages.exercise.pointsNotAvailable')}}</span>
          </div>
          <div class="vertical">
            <transition name="fade">
              <p class="text-green" v-if="submitted">{{$t('pages.exercise.evaluated')}}</p>
            </transition>
          </div>
        </template>
        <template v-else>
          <button @click.prevent="eval" type="submit" class="btn btn-success pull-left" :class="{'small-button':detectMobile() && CelotnoVprasanje.hintCount > 0}">{{($t('pages.exercise.evaluateText'))}}</button>
          <button @click.prevent="hintExercise" v-if="CelotnoVprasanje.hintCount > 0" type="submit" class="btn btn-warning text-center" :class="{'small-button':detectMobile() && CelotnoVprasanje.hintCount > 0}">{{$t('pages.exercise.hintText')}}</button>
          <!-- Gumb in modal za prikaz detaljne resitve -->
          <SolutionModal :CelotnoVprasanje="CelotnoVprasanje" :solutionKeyId="solutionKey" :i="index" :identifier="identifier" :exerciseVersionId="exerciseVersionId" :parentIdentifier="parent"/>
          <!--<button v-if="CelotnoVprasanje.hasSolution" @click.prevent="showSolution" type="submit" class="btn btn-primary pull-right" :class="{'small-button':detectMobile() && CelotnoVprasanje.hintCount > 0}">{{$t('pages.exercise.solvedText')}}</button>-->
        </template>
      </div>
      <div class="clearfix"></div>
      <br>
    </div>
    <!-- HINT AND SOLUTION MODAL -->
    <div class="modal modal-default fade" :id="hintKey" v-if="submitInfo.hintNumber > 0">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exercise.hintText')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div v-for="(eHint, index) in exHints" :key="index">
                <div v-html="translateVhtml(eHint)"></div>
              </div>
            </div>
          </div>
        </div>
      <!-- /.modal-content -->
      </div>
    <!-- /.modal-dialog -->
    </div>
    <!-- HINT AND SOLUTION MODAL -->

  </div>

</template>

<script>
import exerciseEvaluation from '@/components/mixins/ExerciseEvaluation.vue'
import addInputs from '@/components/mixins/AddInputs.vue'
import {mapGetters} from 'vuex'
import ShowSolutionExamResults from '@/components/exercises/ShowSolutionExamResults.vue'
import SolutionModal from '@/components/exercises/SolutionModal.vue'

export default {
  name: 'crypto',
  components: {
    ShowSolutionExamResults,
    SolutionModal
  },
  data () {
    return {
      showLastInput: true,
      splited: [],
      odgovori: [],
      Name: 'crypto',
      selectedAns: null
    }
  },
  computed: {
    ...mapGetters({
      jeAdmin: 'hasAdminRole'
    }),
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin'
    }
  },
  props: ['scoringSettings', 'showAnswer', 'index', 'identifier', 'exerciseVersionId', 'parent'],
  methods: {
    detectMobile () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    clearFields () {
    },
    typing (el) {
      console.log(el.target.innerHTML)
    },
    addFind (value) {
      let tPush = { value: '' }
      if (value) tPush.isText = value
      this.odgovori.push(tPush)
    },
    eval () {
      this.submitInfo.selectedAnswer = '\\begin{verbatim}' + this.selectedAns + '\\end{verbatim}' // hack for verbatim
      this.evalExercise()
    }
  },
  mixins: [exerciseEvaluation, addInputs],
  mounted () {
    // let initialText = this.CelotnoVprasanje.text[this.lng]
    this.splited = this.renderInputs(this.CelotnoVprasanje.text[this.lng], this.CelotnoVprasanje) // begin input, end input
    console.log('splitted', this.splited)
    this.splited.forEach(el => {
      if (el.trim().length === 0) this.addFind(true)
      else this.addFind()
    })
    if (this.odgovori.filter(val => val.isText).length > 0) {
      this.showLastInput = false
    }
    if (this.examResults) {
      this.submitInfo.selectedAnswer = this.CelotnoVprasanje.answer
    }
    console.log('this.CelotnoVprasanje = ', this.CelotnoVprasanje)
    /*
    if (initialText !== this.CelotnoVprasanje.text[this.lng]) {
      this.showLastInput = false
    }
    */
    if (this.submitInfo.selectedAnswer == null && this.examResults) {
      this.submitInfo.selectedAnswer = '\\begin{verbatim}' + '\\end{verbatim}'
    }
  },
  watch: {
    odgovori: {
      handler (oldVal, newVal) {
        let modifyTo = ((newVal.filter(val => val.isText)).map(el => el.value))
        if (modifyTo.length !== 0) this.submitInfo.selectedAnswer = ((newVal.filter(val => val.isText)).map(el => el.value))
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.center {
    margin: auto;
    width: 50%;
    border: 3px solid green;
    padding: 10px;
}
.fa-check {
  color: #00a65a;
}
.fa-times {
  color: #f56954;
}
.exercise-body, .exercise-item {
  padding-left: 1ex;
}
.small-button{
  padding-left: 1em !important;
  padding-right: 1em !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.correct{
  color: #468847;
  background-color: #dff0d8;
  border-color: #468847;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
}
.incorrect{
  color: #b94a48;
  background-color: #f2dede;
  border-color: #b94a48;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
}
</style>



// WEBPACK FOOTER //
// Crypto.vue?6a921c56